import React from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import { useTranslations } from 'next-intl'

import FullName from '~/components/divorce/lookup/search/FullName'
import Email from '~/components/divorce/lookup/search/Email'
import PhoneNumber from '~/components/divorce/lookup/search/PhoneNumber'
import WinItButton from '~/components/WinItButton'
import useInject from '~/hooks/useInject'

const COL_PROPS = {
  fullName: {
    xs: 8,
  },
  input: {
    sm: 4,
    xs: 12,
  },
  button: {
    sm: 4,
    xs: 12,
  },
}

const Form = styled.form`
  appearance: none;
  height: 100%;
  width: 100%;
`

const mapStore = (store) => ({
  isMobile: store.ui.isMobile,
  getFetcherCases: store.divorceLookup.getFetcherCases,
})

const SearchFormContainer = () => {
  const { isMobile, getFetcherCases } = useInject(mapStore)
  const translate = useTranslations('form.general.submit')

  const handleSubmit = async (event) => {
    event.preventDefault()

    await getFetcherCases()
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col {...COL_PROPS.input}>
          <FullName />
        </Col>
        <Col {...COL_PROPS.input}>
          <Email />
        </Col>
      </Row>

      <Row bottom="xs">
        <Col {...COL_PROPS.input}>
          <PhoneNumber />
        </Col>
        <Col {...COL_PROPS.input}>
          <WinItButton
            isMobile={isMobile}
            width="100%"
            height={70}
            style={{ fontSize: '1rem', marginBottom: '2rem' }}
            type="submit"
          >
            {translate('searchRecords')}
          </WinItButton>
        </Col>
      </Row>
    </Form>
  )
}

export default observer(SearchFormContainer)
